import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import type { LabelContent, LabelSize } from "@hisense/shared";
import { buildLabelDocument, labelBarcodeFits } from "@/lib/labelDocument";

export function LabelPreview({ size, content }: { size: LabelSize; content: LabelContent }) {
  const { t } = useTranslation();
  const html = useMemo(() => buildLabelDocument(size, [{ ...content, count: 1 }]), [size, content]);
  const [overflow, setOverflow] = useState(false);
  const missingBarcode = !labelBarcodeFits(size, content.barcode);
  return <div className="space-y-2 rounded-md border border-line bg-sunken/40 p-3">
    <h3 className="text-sm font-semibold text-ink">{t("productWorkspace.labelPreview")}</h3>
    <div className="overflow-auto">
      <div className="inline-block border border-line-strong bg-surface">
      <iframe title={t("productWorkspace.labelPreview")} srcDoc={html} sandbox="allow-same-origin"
        className="block border-0 bg-surface" style={{ width: Math.ceil((size.rotate ? size.heightMm : size.widthMm) * 96 / 25.4), height: Math.ceil((size.rotate ? size.widthMm : size.heightMm) * 96 / 25.4) }}
        onLoad={(event) => {
          const doc = event.currentTarget.contentDocument;
          const elements = doc?.querySelectorAll<HTMLElement>(".label,.title,.line,.code,.foot");
          setOverflow(!!elements && Array.from(elements).some((el) => el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1));
        }} />
      </div>
    </div>
    <p className="text-xs text-ink-soft">{t("productWorkspace.labelPreviewNote")}</p>
    {overflow && <p role="status" className="text-xs text-warn">{t("productWorkspace.labelOverflow")}</p>}
    {missingBarcode && <p role="status" className="text-xs text-warn">{t("productWorkspace.labelUnavailable")}</p>}
  </div>;
}
